@if (data$ | async) {
  <ion-content>
    <div class="background-wrap">
      <div class="img-wrapper-">
        <div class="offer-wrapper-content">
          <div class="top-text">
            <img class="offer-logo" src="../../../assets/icon/offer-logo.png" alt="euromillions" />
            <h2>Win big!</h2>
            <p>PLAY EUROMILLIONS</p>
          </div>
          <div class="bottom-text">
            <h3 class="common-heading common-margin">
              <span class="yellow-text">10 Euromillions lines</span>
              for £1
            </h3>
            <h4 class="join-syndicate-description">Join a ready made syndicate in seconds</h4>
            <ion-button expand="block" class="capsule-btn common-margin join-btn" (click)="goToFreeReg4c()">
              {{'fork2.Join' | translate}}
            </ion-button>
          </div>
        </div>
      </div>
      <div class="syndicate-wrapper">
        <h2 class="common-white-heading-center">{{'fork2.Create' | translate}}</h2>
        <div class="spacer"></div>
        @for (step of steps; track step; let circleIndex = $index) {
          <div class="vertical-align">
            <ion-avatar class="empty-avatar">
              <h1>{{circleIndex + 1}}</h1>
            </ion-avatar>
            <p class="common-text-white avatar-text" [innerHTML]="step"></p>
          </div>
        }
        <ion-button
          expand="block"
          class="capsule-btn common-margin"
          type="submit"
          (click)="startPrivateSyndicateJourney()"
          >
          Create syndicate
        </ion-button>
        <div class="offer-wrapper">
          <div class="decide-later-link" (click)="backToTabs()">{{'fork2.Decide later' | translate}}</div>
        </div>
      </div>
    </div>
  </ion-content>
} @else {
  <ion-skeleton-text animated slot="center" class="skeleton-logo"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-two"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-three"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-one"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-two" style="margin-top: 20px; height: 2vh"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-six"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-seven"></ion-skeleton-text>
}

